import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import VueAwesomeSwiper from "vue-awesome-swiper";
import NProgress from "nprogress";
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import BootstrapVue from "bootstrap-vue";
import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css';

// require styles
import "swiper/dist/css/swiper.css";
import "../node_modules/nprogress/nprogress.css";
import VueProgressBar from "vue-progressbar";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import header from "./components/common/header";
import HeaderNoSearch from "./components/common/header-nosearch";
import "toastr/build/toastr.css";
import "toastr";
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from 'vue-loading-overlay';
import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import VueClockPickerPlugin from '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.plugin.js';
import { Settings } from 'luxon';
import VueDateFns from "vue-date-fns";

Settings.defaultLocale = 'vi';

Vue.component("search-header-layout", header);
Vue.component("no-search-header-layout", HeaderNoSearch);

Vue.use(VueDateFns);
Vue.use(Datetime);
Vue.use(VueClockPickerPlugin);
Vue.use(VueAwesomeSwiper);

Vue.filter("date", VueDateFns);
Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(PerfectScrollbar);
Vue.use(VueTimepicker);

Vue.use(Loading, {
  color: '#28a745'
},{

});

Vue.use(VueProgressBar, {
  color: "rgb(52,195,0)",
  failedColor: "yellow",
  height: "4px"
});

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }
  next();
});

router.afterEach(() => {
  NProgress.done();
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  data: {
    results: []
  },
  mounted() {},
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js